<template>
  <div>
    <el-form-item v-if="activeData.config.fileSize !== undefined" label="文件大小">
      <el-input v-model.number="activeData.config.fileSize" placeholder="请输入文件大小">
        <el-select slot="append" v-model="activeData.config.sizeUnit" :style="{ width: '66px' }">
          <el-option label="KB" value="KB" />
          <el-option label="MB" value="MB" />
          <!-- <el-option label="GB" value="GB" /> -->
        </el-select>
      </el-input>
    </el-form-item>
    <el-form-item label="多选文件">
      <el-switch v-model="activeData.multiple" />
    </el-form-item>
    <el-form-item label="最大文件个数">
      <el-input-number v-model="activeData.limit" />
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'ConfigItemImageUpload',
  props: ['activeData']
}
</script>

<style scoped></style>
